import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { MobileQuickMenu } from 'shared/components';

export const MobileQuickMenuStyled = styled(MobileQuickMenu)(
    ({ theme }) => css`
        position: fixed;
        z-index: 100;

        ${theme.mediaQueries.small} {
            display: inline-flex;
            width: auto;
            left: 50%;
            transform: translateX(-50%);
            justify-content: initial;
        }
    `
);
